import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'

@Component({
  selector: 'app-event-image',
  templateUrl: './event-image.component.html',
  styleUrls: ['./event-image.component.css'],
  standalone: false,
})
export class EventImageComponent implements OnChanges {
  @Input() src: string | null = null
  @Input() alt = 'Esemény képe'
  @Input() height = 160
  @Input() width: number | null = null
  @Input() rounded = false
  @Input() fluid = false
  @Input() showSkeleton = true
  @Input() placeholder = 'assets/event-placeholder.png'
  @Input() square = false

  public isLoading = false
  public currentSrc = this.placeholder

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['src'] || changes['placeholder']) {
      this.updateSrc()
    }
  }

  public onLoad(): void {
    this.isLoading = false
  }

  public onError(): void {
    if (this.currentSrc !== this.placeholder) {
      this.currentSrc = this.placeholder
    }
    this.isLoading = false
  }

  public containerWidth(): string {
    if (this.square && !this.fluid) {
      return `${this.height}px`
    }
    if (this.fluid) {
      return '100%'
    }
    if (this.width) {
      return `${this.width}px`
    }
    return '100%'
  }

  private updateSrc(): void {
    this.currentSrc = this.src || this.placeholder
    this.isLoading = !!this.src && this.showSkeleton
  }
}
